import { createFileRoute } from "@tanstack/react-router";
import YouJustStartedTherapy from "@/pages/articles/YouJustStartedTherapy";
export const Route = createFileRoute(
  "/you-just-started-therapy-at-27-thats-not-late",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "You Just Started Therapy At 27 Thats Not Late | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Starting therapy at 27 isn’t late. Learn about depression treatment options like TMS and SAINT TMS for young adults in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "You Just Started Therapy At 27 Thats Not Late | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Starting therapy at 27 isn’t late. Learn about depression treatment options like TMS and SAINT TMS for young adults in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/you-just-started-therapy-at-27-thats-not-late",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/you-just-started-therapy-at-27-thats-not-late",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <YouJustStartedTherapy />;
}
